export function useFormatacao() {
  const formatarCns = (valor: string): string => {
    if (typeof valor !== 'undefined') {
      return valor.replace(/([0-9]{2})([0-9]{3})([0-9]{1})/, '$1.$2-$3')
    }
    return ''
  }

  const formatCpfCnpj = (value: string): string => {
    if (!value) {
      return ''
    }
    const cleanValue = value.replace(/\D/g, '')
    if (cleanValue.length <= 11) {
      return cleanValue.replace(
        /(\d{3})(\d{3})(\d{3})(\d{1,2})?/,
        '$1.$2.$3-$4'
      )
    } else {
      return cleanValue.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})?/,
        '$1.$2.$3/$4-$5'
      )
    }
  }

  return {
    formatarCns,
    formatCpfCnpj
  }
} 